<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  pixel: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete']);
</script>

<template>
  <tr>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <div class="flex gap-2 font-medium break-words text-n-slate-12">
        {{ pixel.name }}
      </div>
      <div class="block mt-1 text-sm text-n-slate-11">
        {{ $t('META_CAPI_PIXELS.LIST.PIXEL_ID', { id: pixel.pixel_id }) }}
      </div>
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <div class="flex items-center gap-2">
        <span
          class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
          :class="
            pixel.enabled
              ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
              : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
          "
        >
          {{
            pixel.enabled
              ? $t('META_CAPI_PIXELS.STATUS.ACTIVE')
              : $t('META_CAPI_PIXELS.STATUS.INACTIVE')
          }}
        </span>
        <span
          v-if="pixel.test_mode"
          class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200"
        >
          {{ $t('META_CAPI_PIXELS.STATUS.TEST_MODE') }}
        </span>
        <!-- Pixel ligado pelo Gerenciador de Ads (token do login), nao manual -->
        <span
          v-if="pixel.meta_user_id"
          class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-woot-100 text-woot-800 dark:bg-woot-900 dark:text-woot-200"
        >
          <span class="i-lucide-facebook size-3" />
          {{ $t('META_CAPI_PIXELS.STATUS.VIA_LOGIN') }}
        </span>
      </div>
    </td>
    <td class="py-4 min-w-xs">
      <div class="flex justify-end gap-1">
        <Button
          v-tooltip.top="$t('META_CAPI_PIXELS.EDIT.BUTTON_TEXT')"
          icon="i-lucide-pen"
          slate
          xs
          faded
          @click="emit('edit', pixel)"
        />
        <Button
          v-tooltip.top="$t('META_CAPI_PIXELS.DELETE.BUTTON_TEXT')"
          icon="i-lucide-trash-2"
          xs
          ruby
          faded
          @click="emit('delete', pixel, index)"
        />
      </div>
    </td>
  </tr>
</template>
